import React from 'react';
import PropTypes from 'prop-types';

import { GenericTabContainer } from './GenericTabContainer';
import PlanTabContainer from './PlanTabContainer';
import { ProofTabContainer } from './ProofTabContainer';
import { ScrollableTabContainer } from './ScrollableTabContainer';
import { bucketShape, filterShape, tileShape } from '../shapes';

const PLAN_TAB = 'plan';
const PROOF_TAB = 'draft';
const PAGE_SIZE = 16;

export const EditTilesComponent = props => {
  if (props.activeStatus === PLAN_TAB) {
    return (
      <PlanTabContainer
        createNewTilesDigest={props.createNewTilesDigest}
        toggleMonthCollapse={props.toggleMonthCollapse}
      />
    );
  }

  if (props.activeStatus === PROOF_TAB) {
    return (
      <ProofTabContainer
        activeFilters={props.activeFilters}
        activeStatus={props.activeStatus}
        addTileToDigest={props.addTileToDigest}
        canAddTile={false}
        changeTileStatus={props.changeTileStatus}
        handleMenuAction={props.handleMenuAction}
        hasEmptyTileFillers={true}
        isUserSiteAdmin={props.isUserSiteAdmin}
        moveTileBackToPlan={props.moveTileBackToPlan}
        tileDigestPlanDate={null}
        tiles={props.tiles}
        dndContext={props.dndContext}
      />
    );
  }

  if (props.tiles.length > PAGE_SIZE) {
    return (
      <ScrollableTabContainer
        activeFilters={props.activeFilters}
        activeStatus={props.activeStatus}
        changeTileStatus={props.changeTileStatus}
        handleMenuAction={props.handleMenuAction}
        hasEmptyTileFillers={props.activeStatus === PLAN_TAB}
        isUserSiteAdmin={props.isUserSiteAdmin}
        moveTileToProof={props.moveTileToProof}
        pageSize={PAGE_SIZE}
        tiles={props.tiles}
        dndContext={props.dndContext}
      />
    );
  }

  // For some reason infinite scroll breaks after loading a component with less
  // items than one page, for now split them up into two.
  return (
    <GenericTabContainer
      activeFilters={props.activeFilters}
      activeStatus={props.activeStatus}
      changeTileStatus={props.changeTileStatus}
      handleMenuAction={props.handleMenuAction}
      hasEmptyTileFillers={props.activeStatus === PLAN_TAB}
      isUserSiteAdmin={props.isUserSiteAdmin}
      moveTileToProof={props.moveTileToProof}
      tiles={props.tiles}
      dndContext={props.dndContext}
    />
  );
};

EditTilesComponent.propTypes = {
  activeFilters: filterShape,
  activeStatus: PropTypes.string.isRequired,
  addTileToDigest: PropTypes.func.isRequired,
  buckets: PropTypes.objectOf(bucketShape),
  changeTileStatus: PropTypes.func.isRequired,
  createNewTilesDigest: PropTypes.func,
  handleMenuAction: PropTypes.func,
  isUserSiteAdmin: PropTypes.bool,
  moveTileBackToPlan: PropTypes.func,
  moveTileToProof: PropTypes.func.isRequired,
  tiles: PropTypes.arrayOf(tileShape),
  toggleMonthCollapse: PropTypes.func.isRequired,
  dndContext: PropTypes.object,
};
